<div class="mainpanel" [hidden]="!ViewReady">
    <h2 class="mat-title">
        School Groups Editor<span *ngIf="AwardInfo"> - {{AwardInfo.BannerName}}</span>
    </h2>
    <div>
        <div>School groups are collections of similarly managed schools which have different worksite / school numbers, but are considered to be a single entity in the Polk Awards System. For example, a senior high school and an IB school may be combined so that only a single nomination can be specified for the group as a whole, rather than separate nominations for each site.</div>
        <div>Listed below are all of the currently defined school groups for the current school year. Use the provided buttons below to add a new school grouping, edit an existing school grouping, or remove an existing school grouping.</div>
        <div><strong>Note:</strong> The following restrictions exist for the editing or removing of school groups:
            <ul>
                <li>A school grouping must consist of <u>two or more</u> schools. A worksite / school cannot be removed from a school grouping if that would reduce the school grouping to only a single school.</li>
                <li>An individual worksite / school may be a member of only <u>one</u> school grouping.</li>
                <li>A worksite / school <u>cannot</u> be removed from a school grouping if any nominations are active in the Polk Awards System for the currently selected awards program.</li>
                <li>A school grouping <u>cannot</u> be removed from the system if there are any active nominations in the Polk Awards System for any worksites / schools in the school grouping for the currently selected awards program.</li>
            </ul>
        </div>
        <div class="buttongroup" fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center" *ngIf="ShowingGroupPanel !== true">
            <button mat-raised-button color="primary" (click)="ShowGroupPanel()" [disabled]="ShowingGroupPanel">Add New Group</button>
        </div>
    </div>
    <div *ngIf="ShowingGroupPanel" class="mat-elevation-z12 entrypanel" style="margin-bottom:20px">
        <form [formGroup]="GroupEntryForm" novalidate fxLayout="column">
            <h2>
                <span *ngIf="GroupEntryForm.get('SchoolGroupID')?.value != null">School Group #{{GroupEntryForm.get('SchoolGroupID')?.value}} ({{GroupEntryForm.get('OriginalName')?.value}})</span>
                <span *ngIf="GroupEntryForm.get('SchoolGroupID')?.value == null">New School Group</span>
            </h2>
            <div *ngIf="GroupEntryForm.get('Schools')?.value?.length < 2">School groups must have at least 2 worksites / schools added. Use the "Add School" button to add a new school to this group.</div>
            <div fxLayout="column" fxLayoutAlign="start start">
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                    <app-form-label [required]="true">Group Name: </app-form-label>
                    <mat-form-field appearance="outline">
                        <input type="text" matInput formControlName="Name" placeholder="School Group Name" />
                        <mat-hint align="end">{{GroupEntryForm.get('Name')?.value?.length}}/150</mat-hint>
                        <mat-error *ngIf="GroupEntryForm.get('Name')?.hasError('required') && GroupEntryForm.get('Name')?.dirty">Group Name required</mat-error>
                        <mat-error *ngIf="GroupEntryForm.get('Name')?.hasError('maxLength') && GroupEntryForm.get('Name')?.dirty">Limit of 150 characters</mat-error>
                    </mat-form-field>
                </div>
                <table class="mat-table">
                    <thead>
                        <tr class="mat-header-row">
                            <th class="mat-header-cell">School Name</th>
                            <th class="mat-header-cell">School Number</th>
                            <th class="mat-header-cell">Group Leader</th>
                            <th class="mat-header-cell">Action(s)</th>
                        </tr>
                    </thead>
                    <tbody formArrayName="Schools">
                        <tr *ngFor="let schgroup of GroupEntryForm.get('Schools').controls" class="mat-row" [formGroup]="schgroup" [class.pendingremove]="schgroup.get('PendingRemove')?.value">
                            <td class="mat-cell">
                                <mat-form-field *ngIf="schgroup.get('PendingRemove')?.value !== true" appearance="outline" fxFlex>
                                    <mat-select formControlName="SchoolInfo" aria-label="School selection list" placeholder="Select school..." (selectionChange)="UpdateSchool(schgroup)">
                                        <mat-option>Select school...</mat-option>
                                        <mat-option *ngFor="let appsch of AvailableSchools" [value]="appsch">{{appsch.SchoolName}} ({{appsch.SchoolNumber}})</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div *ngIf="schgroup.get('PendingRemove')?.value === true">{{schgroup.get('LocationName')?.value}}</div>
                            </td>
                            <td class="centered mat-cell">
                                <div>{{schgroup.get('LocationNumber')?.value}}</div>
                            </td>
                            <td class="centered mat-cell">
                                <div>{{schgroup.get('IsGroupLeader')?.value === true ? 'Yes' : 'No'}}</div>
                            </td>
                            <td class="centered mat-cell">
                                <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="20px">
                                    <button type="button" *ngIf="schgroup.get('PendingRemove')?.value !== true" mat-raised-button color="primary" [disabled]="schgroup.get('IsGroupLeader')?.value === true || !schgroup.get('LocationNumber')?.value" (click)="SetAsSchoolLeader(schgroup)">Make Group Leader</button>
                                    <button type="button" *ngIf="!schgroup.get('PendingRemove')?.value" mat-raised-button color="warn" [disabled]="GroupEntryForm.get('Schools')?.value?.length <= 2" (click)="RemoveSchool(schgroup)">Remove School</button>
                                    <button type="button" *ngIf="schgroup.get('PendingRemove')?.value" mat-raised-button color="warn" (click)="ReinstateSchool(schgroup)">Reinstate School</button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="actionbuttons">
                    <button type="button" mat-raised-button color="primary" (click)="AddSchool()">Add School</button>
                </div>
            </div>
        </form>
        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
            <button type="button" *ngIf="GroupEntryForm.get('SchoolGroupID')?.value == null" mat-raised-button color="primary" (click)="AddGroup()" [disabled]="GroupEntryForm.invalid">Add</button>
            <button type="button" *ngIf="GroupEntryForm.get('SchoolGroupID')?.value != null" mat-raised-button color="primary" (click)="UpdateGroup()" [disabled]="GroupEntryForm.invalid">Update</button>
            <button type="button" mat-raised-button color="warn" (click)="AddGroupCancelHandler()">Cancel</button>
        </div>
    </div>

    <!-- School Groups Table -->
    <table mat-table #table [dataSource]="GroupsData" matSort matSortActive="Name" matSortDirection="asc">
        <ng-container matColumnDef="SchoolGroupID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Group #</th>
            <td mat-cell *matCellDef="let group" class="centered">{{group.SchoolGroupID}}</td>
        </ng-container>

        <ng-container matColumnDef="Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Group Name</th>
            <td mat-cell *matCellDef="let group" class="centered">{{group.Name}}</td>
        </ng-container>

        <ng-container matColumnDef="Schools">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Schools</th>
            <td mat-cell *matCellDef="let group" class="centered">
                <div *ngIf="!group.Schools || !group.Schools.length">There are no schools defined in this school group.</div>
                <div *ngIf="group.Schools && !!group.Schools.length">
                    <ul>
                        <li *ngFor="let sch of group.Schools">
                            <span>{{sch.LocationName}} ({{sch.LocationNumber}})</span>
                            <span *ngIf="sch.IsGroupLeader"><strong> *Group Leader*</strong></span>
                        </li>
                    </ul>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="centered">Action(s)</th>
            <td mat-cell *matCellDef="let group" class="centered">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" fxLayoutWrap>
                    <button mat-raised-button color="primary" (click)="ShowGroupPanel(group)" class="buttonpad">Edit Group</button>
                    <button mat-raised-button color="warn" (click)="RemoveGroup(group)" [disabled]="ShowingGroupPanel" class="buttonpad">Remove Group</button>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td *matCellDef="let term"><em>There are no school groupings defined for the current school year and awards program in the system.</em></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="AllHeaders"></tr>
        <tr mat-row *matRowDef="let row;columns: AllHeaders;let $even = even" [class.primarybackground50]="$even"></tr>
    </table>
    <mat-paginator #paginator [length]="GroupsData?.data?.length" [pageIndex]="0" [pageSize]="(SmallDisplay ? 5 : 10)" [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>